import React from "react";
const FemaleClipPath = ({ x, clipId }) => {
    return (React.createElement("clipPath", { id: clipId },
        React.createElement("rect", { width: "620", height: "1370", x: x, y: "0" })));
};
export default FemaleClipPath;
//# sourceMappingURL=FemaleClipPath.js.map